import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Route, Redirect, Switch } from 'react-router-dom'
import List from 'containers/project-results/list'
import Results from 'containers/project-results/results'
import Dashboard from 'containers/dashboard'
import ProjectCreation from 'containers/project-creation'
import PrivateRoute from '../utils/private-route'
import Project from 'containers/project'
import ProjectList from 'containers/project/list'
import { parse } from 'query-string'
import { pathOr, path, pathEq, either } from 'ramda'
import { removeAuthCookies } from 'shared/helpers/authentication'
import Scheduler from 'containers/scheduler'
import ThankYou from 'containers/thankyou'
import Interviews from 'containers/interviews'
import Profile from 'containers/profile/index'
import Question from 'components/question'
import { fetchUser } from 'store/user/userActions'
import  Login  from 'components/login'
import  LoginAdmin  from 'components/login-admin'
import  UnSubscribe  from 'components/unSubscribe'
import  UnSubscribedSuccessfully  from 'components/unsubscribed-succesfully'
import UserManagement from 'components/userManagement/index'
import auth from "utils/auth";
import ConferencelinkTranslations from 'containers/dashboard/conference-link-translations'
import TopicNameTranslations from 'containers/dashboard/topic-name-translations'
import Storage from 'shared/helpers/storage'
import { parseJwt } from 'shared/helpers/functional'

import 'less/app.less'
import 'less/snackbar.less'

const renderThankYou = user => routeProps => <ThankYou {...routeProps} user={user} />
const moderatorManagementComponent = props => <Scheduler {...props} key={"isModeratorManagement"}/>
class Routes extends React.Component {

  componentDidMount () {
     //bootIntercom(process.env.INTERCOM_ID)
    window.addEventListener('beforeunload', this._clearAuth)
  }

  componentDidUpdate (prevProps) {
    if (!prevProps.authed && this.props.authed) {
      const nonSubRoutes = ['/thankyou', '/conf', '/preview']
      const needsSubs = nonSubRoutes.every(route => !window.location.pathname.startsWith(route))
      if (needsSubs) {
        const pathnameEq = pathEq(['location', 'pathname'])
        const pathWithoutProjectId = either(pathnameEq('/projects'), pathnameEq('/projects/creation'))
        if (pathWithoutProjectId(this.props)) {
          const params = parse(path(['location', 'search'], this.props))
          this.props.history.replace('/projects')
        }
      }
    }
  }

 
  componentWillUnmount () {
    window.removeEventListener('beforeunload', this._clearAuth)
  }

  _clearAuth = () => {
    const loggedInViaMagicLink = parse(pathOr('', ['location', 'search'], this.props)).commsHash
    if (loggedInViaMagicLink) removeAuthCookies()
  }

  render () {
    const props = this.props
    var redirection;
    var hasProjectManager;
    var hasAdmin;
    if (auth.isAuth()) { 
      const tokenDecoded = parseJwt(Storage.getItem("accessToken"))
      hasProjectManager = this.props.user.userRole === 2 || tokenDecoded['cognito:groups'].includes("QUAL_SCHEDULER_MANAGER")
      hasAdmin = this.props.user.userRole === 3 || tokenDecoded['cognito:groups'].includes("QUAL_SCHEDULER_ADMIN")
      if (hasProjectManager || hasAdmin){
        redirection = "/projects"
      } else {
        redirection = "/interviews"
      }
    } else {
      redirection = "/login"
    }
    return (
      <div>
        <Switch>
          <Route exact path="/">
            <Redirect to={redirection}/>
          </Route>
          <Route exact path={"/unsubscribe/unsubscribe-user/:userId"} {...props} component={UnSubscribe} />
          <Route exact path={"/unsubscribe/success"} component={UnSubscribedSuccessfully} />
          <Route exact path={"/login"} component={Login} />
          
          <Route exact path="/login/admin" component={LoginAdmin} />
          <Route exact path="/thankyou" render={renderThankYou({})} />
          <Route path="/thankyou/:role" render={renderThankYou({})} />
          <Route exact path="/forgotPassword"    {...props} component={Login} />
          <PrivateRoute
            path="/projects"
            component={Project}
            hasAccess = {hasAdmin || hasProjectManager}
            routes={[
              { path: '/projects', component: ProjectList },
              { path: '/projects/creation', component: props => <ProjectCreation {...props} />},
              { path: '/projects/:projectId/dashboard', component: Dashboard },
              { path: '/projects/:projectId/schedule', component: Scheduler },
              { path: '/projects/:projectId/results', component: List },
              { path: '/projects/:projectId/results/interview/:timeSlotId', component: Results },
              { path: '/projects/:projectId/dashboard/conference-link/translations',  component: props => <ConferencelinkTranslations {...props} /> },
              { path: '/projects/:projectId/dashboard/topic-name/translations',  component: props => <TopicNameTranslations  {...props} />}
            ]}
            {...props}
          />
          <PrivateRoute path="/profile" {...props} component={Profile} hasAccess = {true}/>
          <Route path="/scheduler/user/:userId/qstool/:surveyId" {...props} component={Question} />
          <Route exact path="/scheduler/qstool/:surveyId/reschedule" {...props} component={Question} />
          <Route path="/scheduler/qstool/:surveyId/reschedule/:timeSlotId/:rescheduleToken" {...props} component={Question} />
          <PrivateRoute path="/moderator/schedule" {...props} component={Scheduler} hasAccess = {true}/>
          <PrivateRoute path="/moderatorManagement/schedule" {...props}  component={moderatorManagementComponent} hasAccess = {hasAdmin || hasProjectManager} />
          <PrivateRoute path="/interviews" {...props} component={Interviews} hasAccess = {true}/>
          <PrivateRoute path="/userManagement" {...props} component={UserManagement} hasAccess = {hasAdmin}/>
          <Route exact path="/login/user/:id/:token/change-password" {...props} component={Login} ></Route>
          <Route exact path="/login/user/:id/:token/reset-password" {...props} component={Login} ></Route>
        </Switch>
      </div>
    )
  }
}

const mapState = (state) => {
   return {
  authed: state.user.authed,
  attemptedInitialAuth: state.user.attemptedInitialAuth,
  currentProject: state.currentProject,
  user: state.user
}}

const mapDispatch = {
  fetchUser,
  fetchUserForComms: (conferenceHash, userHash) => ({
    type: 'FETCH_USER_FOR_COMMS_REQUESTED',
    payload: { conferenceHash, userHash },
  }),
}

Routes.propTypes = {
  children: PropTypes.element,
}

export default connect(mapState, mapDispatch)(Routes)
